import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchTaxRateChanges = async period => await fetch(
  Config.endpoints.FETCH_TAX_RATE_CHANGES
    .replace(/:periodName/, period)
)
  .then(handleErrors({ errorMessage: 'Fetching Tax Rate Changes failed' }))
  .then(parseAsJson);

